// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"NotesInput_cardTitle__3O35r"};